import React from "react";
import { StarIcon } from "lucide-react";
type StarsProps = {
  className?: string;
};
export function Stars({
  className = "h-4 w-4"
}: StarsProps) {
  return <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-150" data-mp="3gqea948bfdyf">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className={`${className} fill-gold text-gold`} aria-hidden="true" data-id="element-151" data-mp="3pp7zg9jbh21y" />)}
    </div>;
}